export default "__VITE_ASSET__CiJU_guW__$_?format=webp__"